import { Component, OnInit, Input, OnDestroy } from '@angular/core';

import { WidgetModel, WidgetInfoModel, InformationModel } from '../../../../core/models/widget.model';
import { HomeService } from 'src/app/home/service/home.service';

@Component({
  selector: 'app-funnel',
  templateUrl: './funnel.component.html',
  styleUrls: ['./funnel.component.scss']
})
export class FunnelComponent implements OnInit, OnDestroy {

  @Input() public dragged: boolean;
  @Input() public data: WidgetModel;
  @Input() public info: InformationModel[];
  @Input() public scrolling: boolean;

  public timer: any;

  constructor(
    private homeSvc: HomeService
    ) { }

  ngOnInit() {
    this.homeSvc.fetchWidgetData(this.data.id);
    this.timer = window.setInterval(() => {
      this.homeSvc.fetchWidgetData(this.data.id);
    }, this.data.update_timer);
  }

  ngOnDestroy() {
    window.clearInterval(this.timer);
  }

}
